import React from "react";

const sizes = {
  headingxs: "text-[23px] font-bold md:text-[21px]",
  headings: "text-[30px] font-bold md:text-[28px] sm:text-[26px]",
  headingmd: "text-[36px] font-bold md:text-[34px] sm:text-[32px]",
  headinglg: "text-[40px] font-bold md:text-[38px] sm:text-[36px]",
  headingxl: "text-[50px] font-bold md:text-[46px] sm:text-[40px]",
  heading2xl: "text-[96px] font-bold md:text-[48px]",
};

const Heading = ({ children, className = "", size = "headinglg", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`font-ibmplexmono text-gray-50 ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
